export default "__VITE_ASSET__DgbwCRjK__"